import React from "react";

const PLATFORM_LABEL = {
  twitch: "TWITCH",
  youtube: "YOUTUBE",
  kick: "KICK",
};

const PLATFORM_ICON = {
  twitch: "fab fa-twitch",
  youtube: "fab fa-youtube",
  kick: "fas fa-tower-broadcast",
};

/**
 * Red pulsing LIVE pill linking to the stream.
 *
 * Props:
 *  - live: { platform, title, viewer_count, url } | null
 *  - size?: "sm" | "md"
 *  - dataTestid?: string
 *  - showViewers?: boolean (default true)
 */
export function LiveBadge({ live, size = "md", dataTestid = "live-badge", showViewers = true }) {
  if (!live || !live.url) return null;
  const plat = (live.platform || "").toLowerCase();
  const platLabel = PLATFORM_LABEL[plat] || "LIVE";
  const icon = PLATFORM_ICON[plat] || "fas fa-broadcast-tower";
  const pad = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs";
  return (
    <a
      href={live.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={dataTestid}
      title={live.title || "Live now"}
      className={`inline-flex items-center gap-1.5 ${pad} rounded-full bg-red-600 text-white font-bold tracking-widest shadow-lg shadow-red-600/40 hover:bg-red-500 transition`}
    >
      <span className="relative inline-flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-75 animate-ping" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-white" />
      </span>
      <i className={icon} />
      <span>LIVE · {platLabel}</span>
      {showViewers && Number.isFinite(live.viewer_count) && live.viewer_count > 0 && (
        <span className="opacity-90 font-mono">{live.viewer_count.toLocaleString()}</span>
      )}
    </a>
  );
}

export default LiveBadge;
